/* Exotic Blvd :: Shop mega menu helper (megamenu lane, batch 5, 2026-10-24).
   1. The menu photos sit in a closed <details>, so lazy loading would only start them when the menu
      opens. After the page has loaded and the browser is idle, switch them to eager so they are cached
      before the first hover or tap.
   2. F23 (final QA): on touch laptops and tablets a tap on "Shop" fires an emulated hover that opens the
      panel, then the click that follows sees it open and Turbo goes to /collections/shop-all, so the
      panel never shows. For a touch or pen tap (or any click on a device without hover) on the Shop
      link while its panel was closed, open the panel and stop that click. The second tap, or the
      "Shop all" link inside the panel, still goes to the collection. Mouse and keyboard keep Turbo's
      own behaviour (hover opens, click follows the link; Enter opens, Enter again follows). */
(function () {
  'use strict';
  if (window.ebMegaWarm) { return; }
  window.ebMegaWarm = true;
  function warm() {
    var imgs = document.querySelectorAll('.eb-mega img[loading="lazy"], .eb-mega-m img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) { imgs[i].loading = 'eager'; }
  }
  function later() {
    /* speed_b7 2026-10-24: warm only where the desktop panel can open on hover. On phones the menu photos
       (about 200 to 340 KB) were all downloaded on every page; they now load when the menu is opened. */
    if (window.matchMedia && !window.matchMedia('(hover: hover) and (min-width: 799px)').matches) { return; }
    if ('requestIdleCallback' in window) { window.requestIdleCallback(warm, { timeout: 4000 }); }
    else { window.setTimeout(warm, 2500); }
  }
  if (document.readyState === 'complete') { later(); } else { window.addEventListener('load', later); }

  var SUMMARY = '.nav-desktop__tier-1-item > details > summary';
  var noHover = window.matchMedia ? window.matchMedia('(hover: none)') : null;
  var tap = null;
  function shopSummary(target) {
    var s = target && target.closest ? target.closest(SUMMARY) : null;
    if (!s) { return null; }
    var item = s.closest('.nav-desktop__tier-1-item');
    return item && item.querySelector('.eb-mega') ? s : null;
  }
  document.addEventListener('pointerdown', function (e) {
    var s = shopSummary(e.target);
    var touchy = e.pointerType === 'touch' || e.pointerType === 'pen' || (noHover && noHover.matches);
    tap = (s && touchy) ? { summary: s, wasOpen: s.parentNode.hasAttribute('open') } : null;
  }, true);
  document.addEventListener('click', function (e) {
    var t = tap;
    tap = null;
    if (!t) { return; }
    var s = shopSummary(e.target);
    if (s !== t.summary || t.wasOpen) { return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!s.parentNode.hasAttribute('open')) {
      /* Turbo opens this menu on mouseover of its list item (sections.js NavigationDesktopParent). */
      s.closest('.nav-desktop__tier-1-item').dispatchEvent(new MouseEvent('mouseover', { bubbles: true, cancelable: true, view: window }));
    }
  }, true);
})();
